
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';

export const closeNotification = () => ({type: CLOSE_NOTIFICATION});



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationsActions.js